import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
// import { API_URL } from '../common';
import { API_BASE_LOINC } from '../common';

let API_URL = `${API_BASE_LOINC}/api/`;

export interface LoincObjectProperty {
  verbose_name: string;
  value: string;
}

export interface LoincObject {
  [key: string]: LoincObjectProperty;
}

export interface LoincObjectGroup {
  [key: string]: LoincObject;
}

export interface LoincObjectsList {
  count: number;
  next: string;
  previous: string;
  results: LoincObject[];
}

@Injectable({
  providedIn: 'root'
})
export class LoincService {
  baseUrl = `${API_URL}`;
  path = 'loinc/'
  constructor(protected http: HttpClient) {}

  list(query: string = '', page_size: number = 10, page: number = 1, ordering: string = ''): Observable<LoincObjectsList> {
    let params = new HttpParams();
    params = params.set('page_size', page_size);
    params = params.set('page', page);
    params = params.set('q', query);
    params = params.set('ordering', ordering);

    let headers = new HttpHeaders();
    headers = headers.set('Accept-Language', localStorage.getItem('lang') || 'vi');

    return this.http.get<LoincObjectsList>(`${API_URL}${this.path}`, { params: params, headers: headers });
  }

  retrieve(id: string): Observable<LoincObjectGroup> {
    let params = new HttpParams();
    params = params.set('groups', 1);

    let headers = new HttpHeaders();
    headers = headers.set('Accept-Language', localStorage.getItem('lang') || 'vi');

    return this.http.get<LoincObjectGroup>(`${API_URL}${this.path}${id}/`, { params: params, headers: headers });
  }
}

@Injectable({
  providedIn: 'root'
})
export class LoincTableService extends LoincService {
  constructor(protected override http: HttpClient) {
    super(http);
    this.path = this.path + 'loinc-table/'
  }
}

@Injectable({
  providedIn: 'root'
})
export class MapToService extends LoincService {
  constructor(protected override http: HttpClient) {
    super(http);
    this.path = this.path + 'map-to/'
  }
}

@Injectable({
  providedIn: 'root'
})
export class PanelsAndFormsService extends LoincService {
  constructor(protected override http: HttpClient) {
    super(http);
    this.path = this.path + 'panels-and-forms/'
  }
}

@Injectable({
  providedIn: 'root'
})
export class PartService extends LoincService {
  constructor(protected override http: HttpClient) {
    super(http);
    this.path = this.path + 'part/'
  }
}

@Injectable({
  providedIn: 'root'
})
export class LoincPartLinkService extends LoincService {
  constructor(protected override http: HttpClient) {
    super(http);
    this.path = this.path + 'loinc-part-link/'
  }
}

@Injectable({
  providedIn: 'root'
})
export class AnswerListService extends LoincService {
  constructor(protected override http: HttpClient) {
    super(http);
    this.path = this.path + 'answer-list/'
  }
}

@Injectable({
  providedIn: 'root'
})
export class AnswerService extends LoincService {
  constructor(protected override http: HttpClient) {
    super(http);
    this.path = this.path + 'answer/'
  }
}

@Injectable({
  providedIn: 'root'
})
export class LoincAnswerListLinkService extends LoincService {
  constructor(protected override http: HttpClient) {
    super(http);
    this.path = this.path + 'loinc-answer-list-link/'
  }
}
